import "./About.css";
import placeholder from "../../assets/homepage-blur.png"
import josh from "../../assets/Josh-headshot.jpg"


export default function AboutJosh() {
  return (
    <div className="aboutJosh-container" id="about">
      <div className="aboutpage-img">
        <img src={josh} />
        <div className="photocredit">photography by <a href="https://www.instagram.com/blacklodge.portland/" target="_blank" className="link">Tadin Brego</a></div>
      </div>
      <div className="about-josh">
        <p className="homefont hello"><span>Hello there! I'm&nbsp;</span><span className="font-special color-reddish homepage-special"> Joshua N Hsu </span><span>&nbsp;(pronounced 'shoe').</span></p>
        <p className="homefont">
          Born and raised in New York, I'm a second-generation Chinese-American
          storyteller. In my formative years, I attended Manhattan School of
          Music, learning music theory and composition. I enrolled in college at
          the State University of the New York at New Paltz, where I earned my
          B.A. in both Acting and Lighting Design. Later, I received my M.F.A.
          in Directing from the University of California- Irvine.
        </p>
        <p className="homefont">
          Since then, I've been blessed to work in so many different capacities
          in the performing arts, tv, and film. As a director, designer,
          composer, writer, producer, and production consultant, I have worked
          all over the United States.
        </p>
        <p className="homefont">
          More recently, I have also served as Festival Co-Director for PortFringe, Maine's Fringe Festival and headed the Arts and Culture Initative for Maine's first Asian American Community Center. In 2025, I founded Forge Theater Labs, a design-forward, experimental theater lab and podcast collective that develops immersive, boundary-pushing works through collaborative, dramaturgy-driven exploration. I am currently based out of Portland, Maine.
        </p>
      </div>
    </div>
  );
}
